import type { FC } from 'react'

import GlobeIcon from 'mdi-react/GlobeIcon'
import PinIcon from 'mdi-react/PinIcon'

import { Translation } from '@/app/translations/Translation'
import DataPoints, { DataPoint } from '@/components/DataPoints'

import type { PolicyOrderExtended } from '../types'

const EcomPolicyOrderUser: FC<{ order: PolicyOrderExtended }> = ({ order }) => {
  const {
    name,
    customerName,
    departmentName,
    departmentCode,
    phoneCountryId,
    phoneNo,
    userName,
    deliveryAddress,
    deliveryCity,
    deliveryZip,
    policyName,
    contactName,
    contactPhoneNumber,
    isGlobalPolicy,
  } = order
  const departmentInfo = departmentName ? `${departmentCode} - ${departmentName}` : '-'
  const userPhoneNumber = phoneNo ? `+${phoneCountryId} ${phoneNo}` : '-'

  return (
    <section>
      <h3>
        <Translation id="User" />
      </h3>

      <DataPoints>
        <DataPoint header={<Translation id="Company" />} value={customerName} />
        <DataPoint header={<Translation id="Department" />} value={departmentInfo} />
        <DataPoint header={<Translation id="Ordered by" />} value={userName || name} />
        <DataPoint
          header={<Translation id="Policy" />}
          value={
            <div className="flex items-center">
              {policyName ? (
                <>
                  <span>{policyName}</span>
                  {isGlobalPolicy ? (
                    <GlobeIcon className="ml-1 h-4 w-4 fill-gray-500" />
                  ) : (
                    <PinIcon className="ml-1 h-4 w-4 fill-gray-500" />
                  )}
                </>
              ) : (
                '—'
              )}
            </div>
          }
        />
        <DataPoint header={<Translation id="User" />} value={name || '—'} />
        <DataPoint header={<Translation id="Phone number" />} value={userPhoneNumber} />
        <DataPoint
          header={<Translation id="Delivery address" />}
          value={
            <address>
              {deliveryAddress}
              <br />
              {deliveryZip} {deliveryCity}
            </address>
          }
        />
        {contactName && (
          <DataPoint
            header={<Translation id="Contact info" />}
            value={
              <>
                {contactName}
                <br />
                {contactPhoneNumber}
              </>
            }
          />
        )}
      </DataPoints>
    </section>
  )
}

export default EcomPolicyOrderUser
